import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    icon: {
        fontSize: 16,
        display: 'block',
        marginLeft: 0,
    },
    deleted: {
        color: palette.error.main,
    },
    disabled: {
        color: palette.text.secondary,
    },
    enabled: {
        color: palette.success.main,
    },
    unknown: {
        color: palette.primary.light,
    },
}
